module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Row for Freedom: Crossing an Ocean In Search of Hope")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('i')]), _c('i', [_c('a', {
    attrs: {
      "href": "#/chapter3#iwxi",
      "id": "ttxi"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by Bear Grylls")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#iwxv",
      "id": "ttxv"
    }
  }, [_c('i', [_vm._v("Author’s Note: Why Write This Book?")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#iwxix",
      "id": "ttxix"
    }
  }, [_c('i', [_vm._v("Prologue: Fear and Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6#iw1",
      "id": "tt1"
    }
  }, [_vm._v("Part 1: Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter7#iw3",
      "id": "tt3"
    }
  }, [_vm._v("Chapter 1: Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#iw13",
      "id": "tt13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: WAG")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#iw23",
      "id": "tt23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Broken")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#iw29",
      "id": "tt29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Waking")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#iw31",
      "id": "tt31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Deciding to Row an Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#iw41",
      "id": "tt41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Stories We Tell")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#iw49",
      "id": "tt49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Are You Serious?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#iw55",
      "id": "tt55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Which Way Is Up?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#iw63",
      "id": "tt63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Unexpected")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#iw67",
      "id": "tt67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Preparation")]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('p', {
    staticClass: "cct2"
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter17#iw75",
      "id": "tt75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Rowing")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#iw77",
      "id": "tt77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: How Are You Going to Cope?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#iw83",
      "id": "tt83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Forty-eight Hours to Learn It All")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#iw89",
      "id": "tt89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Acceleration Zone")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#iw97",
      "id": "tt97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Stories in the Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#iw103",
      "id": "tt103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Things Fall Apart")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#iw109",
      "id": "tt109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: These Waves Are . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#iw115",
      "id": "tt115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Rope and Glue")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#iw121",
      "id": "tt121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Prayers to Michael")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#iw129",
      "id": "tt129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: It Gets Personal")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#iw135",
      "id": "tt135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Something to Row For")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#iw141",
      "id": "tt141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Gamble")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#iw149",
      "id": "tt149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Golden")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#iw153",
      "id": "tt153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Not Quite Christmas Day")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#iw157",
      "id": "tt157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: New Year, Old Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#iw163",
      "id": "tt163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Change")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#iw169",
      "id": "tt169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: The First Person to See Barbados")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#iw177",
      "id": "tt177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: The Final Day")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#iw185",
      "id": "tt185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The End and the Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#iw191",
      "id": "tt191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: The Missed Bottle")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#iw199",
      "id": "tt199",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#iw203",
      "id": "tt203",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Five Things You Can Do to Fight Human Trafficking")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#iw207",
      "id": "tt207",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#iw213",
      "id": "tt213",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#iw217",
      "id": "tt217",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#iw43",
      "id": "tt43",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photos")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0